var klaviyo = klaviyo || [];
klaviyo.init({
  account: "UjvSyZ",
  platform: "shopify",
});

klaviyo.enable("backinstock", {
  trigger: {
    product_page_text: "Notify Me When Available",
    product_page_class: "klaviyo-trigger",
    product_page_text_align: "center",
    product_page_margin: "0px",
    replace_anchor: false,
  },
  modal: {
    headline: "{product_name}",
    body_content:
      "Register to receive a notification when this item comes back in stock.",
    email_field_label: "Email",
    button_label: "Notify me when available",
    subscription_success_label: "You're in! We'll let you know when it's back.",
    footer_content: "",
    additional_styles: `@font-face {
        font-family: 'bb-modern-regular-pro';
        src: url('https://cdn.shopify.com/s/files/1/0674/2985/9558/files/bb-modern-regular-pro.woff2') format('woff2'),
             url('https://cdn.shopify.com/s/files/1/0674/2985/9558/files/bb-modern-regular-pro.woff') format('woff'),
             url('https://cdn.shopify.com/s/files/1/0674/2985/9558/files/bb-modern-regular-pro.ttf') format('truetype');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'BrownLLWeb-Regular';
        src: url('https://cdn.shopify.com/s/files/1/0674/2985/9558/files/BrownLLWeb-Regular.woff2') format('woff2'),
             url('https://cdn.shopify.com/s/files/1/0674/2985/9558/files/BrownLLWeb-Regular.woff') format('woff');
        font-weight: normal;
        font-style: normal;
    }
    .btn {
      text-transform: uppercase;
      font-family: 'BrownLLWeb-Regular';
      letter-spacing: 1px;
    }
    
    `,
    drop_background_color: "#fff",
    background_color: "#fff",
    text_color: "#100E0D",
    button_text_color: "#fff",
    button_background_color: "#000",
    close_button_color: "#ccc",
    error_background_color: "#fcd6d7",
    error_text_color: "#C72E2F",
    success_background_color: "#fff",
    success_text_color: "#000",
    font_family: "bb-modern-regular-pro",
  },
});
